import { RemoteGetSummaryProfile } from 'data/usecases/dashboard/remote-get-summary-profile';
import { GetSummaryProfile } from 'domain/usecases/dashboard';
import { makeApiUrlSummaryProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSummaryProfile = (): GetSummaryProfile =>
  new RemoteGetSummaryProfile(
    makeApiUrlSummaryProfile(),
    makeAxiosHttpClient(),
  );
